import { ACCESS_TOKEN } from '../static/constants';
import decode from 'jwt-decode';

export const getJwt = () => {
    return localStorage.getItem(ACCESS_TOKEN);
}

export const deleteJwt = () => {
    localStorage.removeItem(ACCESS_TOKEN);
}

export const isTokenExpired = () => {
    let token = localStorage.getItem(ACCESS_TOKEN);
    try {
        const decoded = decode(token);
        if (Number(decoded.exp) < Number(Date.now() / 1000)) { // Checking if token is expired. N
            return true;
        }
        else
            return false;
    }
    catch (err) {
        return false;
    }
}

export const isExternalTokenExpired = (token) => {
    try {
        const decoded = decode(token);
        if (Number(decoded.exp) < Number(Date.now() / 1000)) { // Checking if token is expired. N
            return true;
        }
        else
            return false;
    }
    catch (err) {
        return false;
    }
}

export const isValid = () => {
    let token = localStorage.getItem(ACCESS_TOKEN);
    try {
        const decoded = decode(token);
        if (decoded.jti) { // Checking if token is expired. N
            return true;
        }
        else {
            return false;
        }
    }
    catch (err) {
        return false;
    }
}

export const getMenuPermissions = () => {
    let token = localStorage.getItem(ACCESS_TOKEN);
    try {
        const decoded = decode(token);
        if (decoded.permissions) { // Checking if token is expired. N
            return decoded.permissions;
        }
        else {
            return null;
        }
    }
    catch (err) {
        return null;
    }
}

export const getUserId = () => {
    let token = localStorage.getItem(ACCESS_TOKEN);
    try {
        const decoded = decode(token);
        if (decoded.userid) {
            return decoded.userid;
        }
        else {
            return null;
        }
    }
    catch (err) {
        return null;
    }
}

export const isInternalUser = () => {
    let token = localStorage.getItem(ACCESS_TOKEN);
    try {
        const decoded = decode(token);
        if (decoded.usrInternal) { // Checking if token is expired. N
            return decoded.usrInternal;
        }
        else {
            return false;
        }
    }
    catch (err) {
        return false;
    }
}

export const getUserName = () => {
    let token = localStorage.getItem(ACCESS_TOKEN);
    try {
        const decoded = decode(token);
        if (decoded.sub) {
            return decoded.sub;
        }
        else {
            return null;
        }
    }
    catch (err) {
        return null;
    }
}


// WEBPACK FOOTER //
// ./src/app/utils/auth.js